import { Card, CardMedia, CardContent, Typography } from '@material-ui/core'
import polaroidStaticImg from '../assets/polaroidPreview/polaroidStaticImg.png'
import noBrandLogo from '../assets/polaroidPreview/noBrandLogo.png'
import { makeStyles, createStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() =>
  createStyles({
    polaroidPreview: {
      width: '25vw',
      padding: '30px',
      borderRadius: '5px',
    },
    container: {
      display: 'flex',
      justifyContent: 'center',
    },
    logosWrapper: {
      display: 'grid',
      gridTemplateRows: '1fr',
      alignItems: 'center',
    },
    logoName: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '10px',
    },
    polaroidImg: {
      height: '350px',
      objectFit: 'contain',
      width: 'unset',
      borderRadius: ' 5px 5px 0 0',
      justifySelf: 'center',
    },
    polaroidLogosContainer: {
      display: 'flex',
      justifySelf: 'center',
      justifyContent: 'center',
      width: '155px',
      height: '50px',
      marginBottom: '20px',
    },
    polaroidLogos: {
      maxWidth: '100%',
    },
    polaroidGlassesLogo: {
      maxWidth: '70%',
    },
  })
)

interface PolaroidPreviewProps {
  style: string
  currentLogo: string
  currentBrand?: string
}

const PolaroidPreview: React.FC<PolaroidPreviewProps> = ({
  style,
  currentLogo,
  currentBrand,
}) => {
  const styles = useStyles()
  return (
    <Card className={styles.polaroidPreview}>
      <div className={styles.logosWrapper}>
        <div className={styles.polaroidLogosContainer}>
          <img
            className={styles.polaroidLogos}
            src={
              style === 'No logo template' || style === ''
                ? noBrandLogo
                : currentLogo
            }
            alt="brand-logo"
          />
        </div>
        <div className={styles.logoName}>
          <Typography>
            {' '}
            <b>{currentBrand || 'No Brand'} - Model Name</b>{' '}
          </Typography>
        </div>
      </div>
      <CardMedia
        src={polaroidStaticImg}
        alt="polaroid-static"
        component="img"
        className={styles.polaroidImg}
      />
      <CardContent className={styles.container}>
        <div>
          <Typography>
            Frame Color : <b> Light Blue</b>
          </Typography>
          <Typography>
            Lens Color : <b> Purple Unicorn</b>
          </Typography>
        </div>
      </CardContent>
    </Card>
  )
}

export default PolaroidPreview
